/**
 * Loading animation component
 */
export const Loader = () => (
  <div id="loader">
    <div className="lds-ripple" />
  </div>
);
